import { render } from "./PrefectureViews.vue?vue&type=template&id=7d41c42c&scoped=true"
import script from "./PrefectureViews.vue?vue&type=script&lang=js"
export * from "./PrefectureViews.vue?vue&type=script&lang=js"

import "./PrefectureViews.vue?vue&type=style&index=0&id=7d41c42c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d41c42c"]])

export default __exports__